<template>
  <div>
    <b-row>
      <b-col md="12">
        <h4>Contracts Dashboard</h4>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col md="12">
        <b-button
          variant="primary"
          class="mx-1"
          :to="{ name: 'contractList' }"
          exact
          >View Active Contracts</b-button
        >
        <b-button
          variant="primary"
          class="mx-1"
          v-if="isContractManager"
          :to="{ name: 'contractAdd' }"
          exact
          >Add Contract</b-button
        >
        <!-- <b-button variant="primary" class="mx-1" :to="{name: 'siteAdd'}" v-if="isContractManager" exact>Add Site</b-button> -->
      </b-col>
    </b-row>

    <div>
      <h3>Contracts Aggregates</h3>
      <b-row>
        <b-col md="4">
          <widget heading="Contract Stages">
            <b-table
              :fields="contractStageFields"
              :items="contractStageCounts"
              small
              striped
              bordered
            ></b-table>
            <doughnut-chart
              :chart-data="contractStageCountData"
            ></doughnut-chart>
          </widget>
        </b-col>
        <!-- <b-col md="4">
          <widget heading="Stage Averages - Standard">
            <stage-averages :stageAverages="standardStageAverages"></stage-averages>
          </widget>
        </b-col>
        <b-col md="4">
          <widget heading="Stage Averages - Non-Standard">
            <stage-averages :stageAverages="nonStandardStageAverages"></stage-averages>
          </widget>
        </b-col> -->

        <b-col md="4">
          <widget heading="Contracts Completed">
            <b-table
              :fields="completedContractFields"
              :items="completedContracts"
              sort-by="year"
              :sort-desc="false"
              :per-page="completedPerPage"
              show-empty
              small
              striped
              bordered
              class="mt-2"
            >
            </b-table>
            <b-button
              @click="completedPerPage = 0"
              variant="primary"
              v-if="
                completedContracts.length > completedPerPage &&
                completedPerPage > 0
              "
              >Show More</b-button
            >
          </widget>
        </b-col>

        <b-col md="4">
          <widget heading="Contracts Expiring Between">
            <b-row>
              <b-col md="6">
                <datepicker
                  inputClass="form-control"
                  format="MM/dd/yyyy"
                  :typeable="true"
                  v-model="contractExpireDateStart"
                  @input="updateExpiringContracts()"
                ></datepicker>
              </b-col>
              <b-col md="6">
                <datepicker
                  inputClass="form-control"
                  format="MM/dd/yyyy"
                  class="left"
                  :typeable="true"
                  v-model="contractExpireDate"
                  @input="updateExpiringContracts()"
                ></datepicker>
              </b-col>
            </b-row>
            <div class="pull-right">
              <b>Count: {{ expiringContracts.length }}</b>
            </div>
            <b-table
              :fields="expiringContractFields"
              :items="expiringContracts"
              show-empty
              :per-page="expiringPerPage"
              small
              striped
              bordered
              class="mt-2"
            >
              <template slot="name" slot-scope="data">
                <router-link
                  :to="{
                    name: 'contract',
                    params: { id: data.item.contractId },
                  }"
                  >{{ data.item.name }}</router-link
                >
              </template>
              <template slot="endDate" slot-scope="data">
                {{ data.item.endDate | formatDate }}
              </template>
            </b-table>
            <b-button
              @click="expiringPerPage = 0"
              variant="primary"
              v-if="
                expiringContracts.length > expiringPerPage &&
                expiringPerPage > 0
              "
              >Show More</b-button
            >
          </widget>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import StageAverages from "./stage-averages";
import Widget from "../../components/widget";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {
      contractStageFields: [{ key: "name", label: "Stage" }, { key: "count" }],
      completedContractFields: [
        { key: "year", sortable: true },
        { key: "count", sortable: true },
      ],
      expiringContractFields: [
        { key: "name", label: "Contract", sortable: true },
        { key: "endDate", label: "End Date", sortable: true },
      ],
      colors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColors: [
        "rgba(255,99,132,1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      contractExpireDate: null,
      contractExpireDateStart: null,
      completedPerPage: 5,
      expiringPerPage: 5,

      // isContractManager: false,
      // isContractViewer: false
    };
  },

  components: {
    "stage-averages": StageAverages,
    widget: Widget,
  },

  methods: {
    updateExpiringContracts: function () {
      this.$store.dispatch("home/getExpiringContracts", {
        startDate: this.contractExpireDateStart,
        endDate: this.contractExpireDate,
      });
    },
  },

  computed: {
    contractStageCounts: function () {
      return this.$store.state.home.contracts.contractStageCounts;
    },

    standardStageAverages: function () {
      return this.$store.state.home.contracts.standardStageAverages;
    },

    nonStandardStageAverages: function () {
      return this.$store.state.home.contracts.nonStandardStageAverages;
    },

    // format data
    contractStageCountData: function () {
      var that = this;

      if (this.contractStageCounts.length) {
        var formattedData = {
          labels: [],
          datasets: [
            {
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
              data: [],
            },
          ],
        };

        var colorIndex = 0;
        _.forEach(this.contractStageCounts, function (contractStageCount) {
          formattedData.labels.push(contractStageCount.name);
          formattedData.datasets[0].data.push(contractStageCount.count);
          formattedData.datasets[0].backgroundColor.push(
            that.colors[colorIndex]
          );
          formattedData.datasets[0].borderColor.push(
            that.borderColors[colorIndex]
          );
          if (colorIndex < that.colors.length - 1) {
            colorIndex++;
          } else {
            colorIndex = 0;
          }
        });

        return formattedData;
      }
      return null;
    },

    completedContracts: function () {
      return this.$store.state.home.contracts.completedContracts;
    },

    expiringContracts: function () {
      return this.$store.state.home.contracts.expiringContracts;
    },
  },

  created() {
    this.$store.dispatch("home/getContractStageCounts");
    this.$store.dispatch("home/getStandardStageAverages");
    this.$store.dispatch("home/getNonStandardStageAverages");
    this.$store.dispatch("home/getCompletedContracts");

    this.contractExpireDateStart = new Date();
    this.contractExpireDate = new Date();
    this.updateExpiringContracts();

    this.isContractManager = this.$store.isContractManager;
    console.log("MANAGER");
    console.log(this.isContractManager);

    // this.isContractViewer =  this.$store.isContractViewer;
  },
};
</script>

<style >
.top .vdp-datepicker__calendar {
  position: absolute;
  top: -282px;
}

.left .vdp-datepicker__calendar {
  position: absolute;
  left: -145px;
}

/* .btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
} */
</style>
